export default "__VITE_ASSET__65bf0f22__"